module.exports = __webpack_public_path__ + "img/no-img-sample.21027234.png";